// JavaScript Document
document.addEventListener('DOMContentLoaded', () => {
  const root = document.getElementById('Therapy');
  if (!root) return;

  const animatedElements = root.querySelectorAll('.anime');
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('active');
        }
      });
    }, { threshold: 0.1 });

    animatedElements.forEach((element) => observer.observe(element));
  } else {
    animatedElements.forEach((element) => element.classList.add('active'));
  }
});
	
	// 浮遊
	function initFluffyAnimation() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  const random = (min, max) => Math.random() * (max - min) + min;

  document.querySelectorAll('.fluffy').forEach((item) => {
    if (item.dataset.fluffyInitialized) return;
    item.dataset.fluffyInitialized = 'true';

    const x = random(3, 10);       // 左右の移動量（px）
    const y = random(8, 20);       // 上下の移動量（px）
    const direction = Math.random() < 0.5 ? -1 : 1;
    const duration = random(4000, 7000); // 1往復の時間（ms）

    item.animate(
      [
        { transform: 'translate(0, 0)' },
        {
          transform: `translate(${x * direction}px, ${-y}px)`,
          offset: 0.5,
        },
        { transform: 'translate(0, 0)' },
      ],
      {
        duration,
        iterations: Infinity,
        easing: 'ease-in-out',
        delay: -random(0, duration),
      }
    );
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFluffyAnimation);
} else {
  initFluffyAnimation();
}
	
	// rudius
	function initRadius50() {
  const observer = new ResizeObserver((entries) => {
    entries.forEach(({ target }) => {
      const width = target.getBoundingClientRect().width;
      target.style.borderRadius = `${width / 2}px`;
    });
  });

  document.querySelectorAll('.rudius50').forEach((element) => {
    observer.observe(element);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initRadius50);
} else {
  initRadius50();
}
	
	// スライダー
	function initSimpleSlider() {
  document.querySelectorAll('.simple-slider').forEach((slider) => {
    const track = slider.querySelector('.simple-slider__track');
    const slides = slider.querySelectorAll('.simple-slider__slide');
    const dots = slider.querySelectorAll('.simple-slider__dots button');

    if (!track || slides.length < 2) return;

    let currentIndex = 0;
    let timer;

    function showSlide(index) {
  currentIndex = index;

  // スライドの横幅と隙間を取得
  const slideWidth = slides[0].getBoundingClientRect().width;
  const gap = parseFloat(getComputedStyle(track).columnGap) || 0;

  // 隙間を含めた距離だけ移動
  const moveX = (slideWidth + gap) * index;
  track.style.transform = `translateX(-${moveX}px)`;

  dots.forEach((dot, i) => {
    const isActive = i === index;
    dot.classList.toggle('is-active', isActive);
    dot.setAttribute('aria-pressed', String(isActive));
  });
}
	  const resizeObserver = new ResizeObserver(() => {
  showSlide(currentIndex);
});

resizeObserver.observe(slider);

    function startAutoPlay() {
      clearInterval(timer);

      timer = setInterval(() => {
        showSlide((currentIndex + 1) % slides.length);
      }, 4000);
    }

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        showSlide(index);
        startAutoPlay();
      });
    });

    showSlide(0);
    startAutoPlay();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSimpleSlider);
} else {
  initSimpleSlider();
}
	
	<!-- Fonts -->
    (function(d) {
    var config = {
      kitId: 'qap6aby',
      scriptTimeout: 3000,
      async: true
    },
    h=d.documentElement,t=setTimeout(function(){h.className=h.className.replace(/\bwf-loading\b/g,"")+" wf-inactive";},config.scriptTimeout),tk=d.createElement("script"),f=false,s=d.getElementsByTagName("script")[0],a;h.className+=" wf-loading";tk.src='https://use.typekit.net/'+config.kitId+'.js';tk.async=true;tk.onload=tk.onreadystatechange=function(){a=this.readyState;if(f||a&&a!="complete"&&a!="loaded")return;f=true;clearTimeout(t);try{Typekit.load(config)}catch(e){}};s.parentNode.insertBefore(tk,s)
  })(document);